var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var isDocumentsCompleted = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (data && Array.isArray(data === null || data === void 0 ? void 0 : data.identity)) {
        return (((data.identity.find(function (doc) { return doc.type === 'passport'; })
            || (data.identity.find(function (doc) { return doc.type === 'id_card_recto'; }) && (data === null || data === void 0 ? void 0 : data.identity.find(function (doc) { return doc.type === 'id_card_verso'; }))))
            && data.identity.find(function (doc) { return doc.type === 'home_certificate'; }) && true) || false);
    }
    if (!(data === null || data === void 0 ? void 0 : data.identity)) {
        return false;
    }
    var identity = data === null || data === void 0 ? void 0 : data.identity;
    return (identity
        && ((((_a = identity.passport) === null || _a === void 0 ? void 0 : _a.name) || ((_b = identity.passport) === null || _b === void 0 ? void 0 : _b.file))
            || ((((_c = identity.idFront) === null || _c === void 0 ? void 0 : _c.name) || ((_d = identity.idFront) === null || _d === void 0 ? void 0 : _d.file))
                && (((_e = identity.idBack) === null || _e === void 0 ? void 0 : _e.name) || ((_f = identity.idBack) === null || _f === void 0 ? void 0 : _f.file))))
        && (((_g = identity.proofOfAddress) === null || _g === void 0 ? void 0 : _g.name) || ((_h = identity.proofOfAddress) === null || _h === void 0 ? void 0 : _h.file))) !== undefined;
};
export var isGeneralInformationComplete = function (data) {
    var _a, _b, _c, _d, _e;
    return (((_a = data === null || data === void 0 ? void 0 : data.general) === null || _a === void 0 ? void 0 : _a.firstName)
        && ((_b = data === null || data === void 0 ? void 0 : data.general) === null || _b === void 0 ? void 0 : _b.nationality) && ((_c = data === null || data === void 0 ? void 0 : data.general) === null || _c === void 0 ? void 0 : _c.lastName)
        && ((_d = data === null || data === void 0 ? void 0 : data.general) === null || _d === void 0 ? void 0 : _d.gender) && ((_e = data === null || data === void 0 ? void 0 : data.general) === null || _e === void 0 ? void 0 : _e.birthday)) !== undefined || false;
};
export var isResidenceComplete = function (data) {
    var _a, _b, _c, _d, _e, _f;
    return (((_a = data === null || data === void 0 ? void 0 : data.residence) === null || _a === void 0 ? void 0 : _a.city) && ((_b = data === null || data === void 0 ? void 0 : data.residence) === null || _b === void 0 ? void 0 : _b.country) && ((_c = data === null || data === void 0 ? void 0 : data.residence) === null || _c === void 0 ? void 0 : _c.address)
        && ((_d = data === null || data === void 0 ? void 0 : data.residence) === null || _d === void 0 ? void 0 : _d.streetNumber) && ((_e = data === null || data === void 0 ? void 0 : data.residence) === null || _e === void 0 ? void 0 : _e.zipCode)
        && ((_f = data === null || data === void 0 ? void 0 : data.residence) === null || _f === void 0 ? void 0 : _f.usResident)) !== undefined || false;
};
export var isAppropriatenessComplete = function (data) { return ((data === null || data === void 0 ? void 0 : data.goalInvestmentByAyomi)
    && (data === null || data === void 0 ? void 0 : data.paidUpShare) && (data === null || data === void 0 ? void 0 : data.experienceTrading) && (data === null || data === void 0 ? void 0 : data.tradingSizeByYear)
    && (data === null || data === void 0 ? void 0 : data.transferableSecurities)) || false; };
export var isSuitabilityComplete = function (data) { return ((data === null || data === void 0 ? void 0 : data.levelOfEducation)
    && (data === null || data === void 0 ? void 0 : data.sectorOccupation) && (data === null || data === void 0 ? void 0 : data.occupation)
    && (data === null || data === void 0 ? void 0 : data.annualIncome) && (data === null || data === void 0 ? void 0 : data.employmentPosition)
    && (data === null || data === void 0 ? void 0 : data.currentNetPortfolio) && (data === null || data === void 0 ? void 0 : data.plannedInvestmentPerMonth) && (data === null || data === void 0 ? void 0 : data.purposeOfInvestment)
    && (data === null || data === void 0 ? void 0 : data.levelOfRisk) && (data === null || data === void 0 ? void 0 : data.sourceOfFunds) && true) || false; };
export default function isIndividualKycComplete(state) {
    var inputs = ['general', 'residence', 'suitability', 'appropriateness'];
    var initialResult = { isComplete: false, step: [] };
    var result = inputs.reduce(function (acc, curr) {
        var _a, _b;
        var isCurrComplete = (_b = (_a = state[curr]) === null || _a === void 0 ? void 0 : _a.isComplete) !== null && _b !== void 0 ? _b : false;
        return {
            isComplete: acc.isComplete && isCurrComplete,
            step: !isCurrComplete ? __spreadArray(__spreadArray([], acc.step, true), [curr], false) : acc.step,
        };
    }, initialResult);
    var documentsCompleted = isDocumentsCompleted(state.general);
    result.isComplete = result.isComplete && documentsCompleted;
    if (!documentsCompleted) {
        result.step = __spreadArray(['identity', 'proofOfAddress'], result.step, true);
    }
    return __assign(__assign({}, result), { status: state.status });
}
